export default __webpack_public_path__ + "static/minko-gechev-f28f19d9241147cadd162a847d210a72.jpg";